import { isDevEnvironment } from './environment';

// Reescreve domínios de produção para equivalentes .dev quando em ambiente de desenvolvimento
export function rewriteProdToDev(html) {
  if (!isDevEnvironment() || !html) return html;

  const mapping = {
    'https://static.agendario.com.br': 'https://static.dev.agendario.com.br',
    'https://data.agendario.com.br':   'https://data.dev.agendario.com.br',
    'https://pages.agendario.com.br':  'https://pages.dev.agendario.com.br',
    'https://share.agendario.com.br':  'https://share.dev.agendario.com.br',
    'https://upload.agendario.com.br': 'https://upload.dev.agendario.com.br',
    'https://images.agendario.com.br': 'https://images.dev.agendario.com.br',
    'https://photo.agendario.com.br':  'https://photo.dev.agendario.com.br',
    'https://photos.agendario.com.br': 'https://photos.dev.agendario.com.br',
    'https://api.agendario.com.br':    'https://api.dev.agendario.com.br',
  };

  let out = html;
  Object.keys(mapping).forEach((prod) => {
    out = out.split(prod).join(mapping[prod]);
  });
  return out;
}
